import React, { ReactNode } from 'react';
import './ExposicaoCard.css';

interface ExposicaoCardProps {
  title: string;
  description: string;
  visitasGuiadas?: string;
  children?: ReactNode;
}

export const ExposicaoCard: React.FC<ExposicaoCardProps> = ({ 
  title, 
  description, 
  visitasGuiadas,
  children
}) => {
  return (
    <div className="exposicao-card">
      <div className="exposicao-content">
        <h3 className="exposicao-title">{title}</h3>
        <p className="exposicao-description">{description}</p>
        <p className="visitas-guiadas">{visitasGuiadas}</p>
        {children}
      </div>
    </div>
  );
}; 